import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useUser } from '../../../../context/UserContext';
import Button from '../../../../components/general/Button/Button';
import Input from '../../../../components/general/Input/Input';
import Alert from '../../../../components/intern/Alert/Alert';
import { updateUser } from '../../../../store/actions/authActions';
import gsap from 'gsap';
import './PerfilPage.css';

const PerfilPage = () => {
  const dispatch = useDispatch();
  const user = useUser();
  const [name, setName] = useState(user.userDb?.displayName || user.userDb?.userName || 'Usuario sem nome');
  const [profilePic, setProfilePic] = useState(user?.userDb?.photoURL || '');
  const [alertType, setAlertType] = useState(null);
  const [uploading, setUploading] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    gsap.from(containerRef.current, {
      y: 20,
      duration: 0.5,
      ease: 'power2.out'
    });
  }, []);

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('uid', user.authUser.uid); // envia UID para o backend

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/images/profiles`, {
        method: 'POST',
        body: formData,
      });

      if (!res.ok) throw new Error('Erro no upload');

      const data = await res.json();
      setProfilePic(data.url); // atualiza imagem do perfil com a URL retornada
      setAlertType('adicionar');
    } catch (error) {
      console.error(error);
      setAlertType('erro');
    } finally {
      setUploading(false);
    }
  };

  const handleSave = useCallback(async () => {
    if (name === user?.userDb?.displayName && profilePic === user?.userDb?.photoURL) {
      setAlertType('nenhumaAlteracao');
      return;
    }
    try {
      await dispatch(updateUser({ userName: name, photoURL: profilePic }));
      setAlertType('adicionar');
    } catch {
      setAlertType('erro');
    }
  }, [dispatch, name, profilePic, user]);

  return (
    <section ref={containerRef} className="perfil-page-section">
      {alertType && <Alert type={alertType} onClose={() => setAlertType(null)} />}

      <Helmet>
        <title>My Account </title>
      </Helmet>

      <div className="profile-header">
        <div className="profile-pic-section">
          <h2 className="profile-name">{name}</h2>
          <img
            src={profilePic}
            alt={`Foto de perfil de ${name}`}
            className="profile-pic"
            loading="lazy"
          />

          <div className="image-upload-section">
            <h3 className="title-image-selection">Enviar nova imagem de perfil</h3>
            <input
              type="file"
              accept="image/*"
              onChange={handleUpload}
              disabled={uploading}
            />
            {uploading && <p>Enviando imagem...</p>}
          </div>
        </div>

        <div className="profile-details">
          <Input
            className="input-disable"
            type="text"
            placeholder="ID"
            value={user?.authUser?.uid || 'sem ID cadastrado'}
            onChange={() => { }}
            label="ID"
            disabled
          />
          <Input
            className="input-disable"
            type="text"
            placeholder="E‑mail"
            value={user?.userDb?.userEmail || 'sem e‑mail cadastrado'}
            onChange={() => { }}
            label="E‑mail"
            disabled
          />
          <div className="button-container">
            <Button
              type="button"
              variant="save"
              className="btn-save"
              onClick={handleSave}
            >
              Salvar Alterações
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PerfilPage;
